/**
 * In-memory Map for MFA credentials.
 * Avoids putting email, password, SSO tokens in location.state.
 * Credentials are consumed on read (one-time use).
 */

const map = new Map<string, { data: Record<string, unknown>; ts: number }>();
const TTL_MS = 5 * 60 * 1000;

function randomId(): string {
  return `mfa_${Date.now()}_${Math.random().toString(36).slice(2)}`;
}

export function storeMfaCredentials(data: Record<string, unknown>): string {
  const id = randomId();
  map.set(id, { data, ts: Date.now() });
  return id;
}

export function takeMfaCredentials(
  id: string | undefined,
): Record<string, unknown> | null {
  if (!id || typeof id !== 'string') return null;

  const entry = map.get(id);
  map.delete(id);

  if (!entry || Date.now() - entry.ts > TTL_MS) return null;
  return entry.data;
}
